import React from 'react'
import './VersionStatus.scss'
import { VersionStatusProps } from './VersionStatus.types'
import { Chip } from '@material-ui/core'

export function VersionStatus({ version }: VersionStatusProps) {
  const [color, text] = version.uploaded ? ['primary', 'Uploaded'] : ['secondary', 'Pending']
  return <Chip color={color as any} label={text} />
}
